// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/element_variables.scss
// module id = yv97
// module chunks = 6